/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  TextField,
  IconButton,
  Drawer,
  Button,
  Typography,
  Select,
  MenuItem,
  Grid,
  FormControlLabel,
  Radio,
  DialogContent,
  Dialog,
  Popover,
  List,
  ListItem,
  Portal,
  CircularProgress,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
import { environment } from '../../environments/environment';
import { useNavigate } from 'react-router-dom';
import { Edit } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { ButtonK, InputField } from '@datascient/datascient-ui-library';
import ChipInput from 'datascient-ui-library/src/lib/Molecules/MultiInputField/MultiInput';
import Add from '@mui/icons-material/Add';
import AddButton from 'datascient-ui-library/src/lib/Molecules/AddButton/AddButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ConfigurationForm = ({ configuration, selectedRowData,readOnlyFlag }) => {
  const [formValues, setFormValues] = useState(configuration);

  // Update form value dynamically
  const handleInputChange = (event, sectionKey, fieldKey) => {
    setFormValues((prevState) => ({
      ...prevState,
      [sectionKey]: {
        ...prevState[sectionKey],
        [fieldKey]: event.target.value,
      },
    }));
  };

  const handleSave = async() => {
    try {
      const data = {
        data: {
          org_id: localStorage.getItem('org_id'),
       
          activity_template_configuration_items: [
            {
              id:selectedRowData.id,
              activity_template_name:  selectedRowData.activity_template_name,
              configuration: formValues,
              activity_template_code: selectedRowData.activity_template_code || null,
            }
          ]
        },
      };
      const res = await axios.post(
        `${environment.apiUrl}/agent/updateCustomActivityTemplateConfigurationForOrg`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
    
    } catch (error) {
      console.log('error', error);
      if (
        error?.response?.data?.error === 'jwt malformed' ||
        error?.response?.data?.error === 'jwt expired'
      ) {
        console.log(error?.response?.data?.error);
        // navigate('/login');
      }
    }
  };

  return (
    <Paper sx={{ 
      padding: 3, 
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
    }}>
     
      <Grid container spacing={3}>
  {Object?.entries(formValues)?.map(([sectionKey, sectionValue]) => (
    <Grid item xs={12} key={sectionKey}>
      <Typography variant="subtitle1" gutterBottom>
        {sectionKey.toUpperCase()}
      </Typography>
      <Grid container spacing={2} sx={{ marginLeft: 1 }}>
        {typeof sectionValue === 'object' ? (
          Object?.entries(sectionValue)?.map(([fieldKey, fieldValue]) => (
            <Grid item xs={6} key={fieldKey}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="body2" sx={{ width: 150 }}>
                  {fieldKey}:
                </Typography>
                <TextField
                  variant="outlined"
                  size="small"
                  value={fieldValue}
                  onChange={(event) => handleInputChange(event, sectionKey, fieldKey)}
                  sx={{ flex: 1 }}
                  disabled={readOnlyFlag}
                />
              </Box>
            </Grid>
          ))
        ) : (
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              size="small"
              label={sectionKey}
              value={sectionValue}
              onChange={(event) => handleInputChange(event, sectionKey)}
              fullWidth
              disabled={readOnlyFlag}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  ))}
</Grid>


{!readOnlyFlag && <Box sx={{ textAlign: 'right', marginTop: 2 }}>
      <ButtonK
            text="Save"
            color="#131F32"
            backgroundColor="#FFD600"
            sx={{
              margin: '0 auto',
              display: 'block',
              marginTop: '20px !important',
              width: '200px',
              borderRadius: '10px !important',
              fontSize: '14px !important',
              fontWeight: '600',
              boxShadow: '0 4px 8px rgba(0,0,0,0.3)', // Adding a subtle shadow
              transition: 'background-color 0.3s, transform 0.3s', // Adding smooth transitions
              '&:hover': {
                backgroundColor: '#1565c0', // Change to a different color on hover
                transform: 'scale(1.05)', // Adding a slight scale effect on hover
              },
            }}
            handleClick={handleSave}
         
          />
      </Box>}
     
    </Paper>
  );
};
















const AdminActivityTemplates = () => {
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [prefillInputObj, setPrefillInput] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false); // State for drawer
  const [selectedRowData, setSelectedRowData] = useState(null); // State for selected row
  const [activityTypesForOrg, setActivityTypesForOrg] = useState();
  const navigate = useNavigate();
  const [readOnlyFlag,setReadOnlyFlag]=useState(false);
  const [configuration,setconfiguration]=useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [editConfiguration, setEditConfiguration] = useState([]);
  const [editPrimaryInput, setEditPrimaryInput] = useState([]);
  const [editPrimaryOutput, setEditPrimaryOutput] = useState(null);
  const [openPopover, setOpenPopover] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [addFlag,setaddFlag]=useState(true);

  const getEditableActivityTemplateForOrg = async () => {
    try {
      const data = {
        data: {
          activity_class: ['AGENT'],
        },
      };
      const res = await axios.post(
        `${environment.apiUrl}/agent/getEditableActivityTemplateForOrg`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      setTableData(res?.data);
      setFilteredData(res?.data);
    } catch (error) {
      console.log('error', error);
      if (
        error?.response?.data?.error === 'jwt malformed' ||
        error?.response?.data?.error === 'jwt expired'
      ) {
        console.log(error?.response?.data?.error);
        navigate('/login');
      }
    }
  };
  const getActivityTemplateDetails = async (rowData) => {
    try {
      const data = {
        data: {
          activity_template_code: rowData.activity_template_code || null,
        },
      };
      const res = await axios.post(
        `${environment.apiUrl}/agent/getTasksForActivityTemplate`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      setEditConfiguration(res?.data?.configuration?.taskConfiguration);
      setEditPrimaryInput(res?.data?.configuration?.primary_input || []);
      setEditPrimaryOutput(res?.data?.configuration?.primary_output || null);
    } catch (error) {
      console.log('error', error);
      if (
        error?.response?.data?.error === 'jwt malformed' ||
        error?.response?.data?.error === 'jwt expired'
      ) {
        console.log(error?.response?.data?.error);
        navigate('/login');
      }
    }
  };

  const handleAddRow = (key) => {
    setEditConfiguration((prevConfig) =>
      prevConfig?.map((field) =>
        field.key === key
          ? {
              ...field,
              value: [
                ...field.value,
                // Initialize new row with empty values for each column
                field.columnHeaders.reduce(
                  (newRow, header) => ({
                    ...newRow,
                    [header.key]: '',
                  }),
                  {}
                ),
              ],
            }
          : field
      )
    );
  };

  const getActivityTypes = async () => {
    try {
      const data = {
        data: {
          org_id: localStorage.getItem('org_id'),
          campaign_type: 'DEFAULT',
        },
      };
      const res = await axios.post(
        `${environment.apiUrl}/agent/getActivityTypeForOrg`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      setActivityTypesForOrg(res?.data);
    } catch (error) {
      console.log('error', error);
      if (
        error?.response?.data?.error === 'jwt malformed' ||
        error?.response?.data?.error === 'jwt expired'
      ) {
        console.log(error?.response?.data?.error);
        navigate('/login');
      }
    }
  };

  const getActivityTemplateConfigurationDetails = async (rowData) => {
    try {
      const data = {
        data: {
          org_id: localStorage.getItem('org_id'),
          activity_template_code: rowData.activity_template_code || null,
        },
      };
      const res = await axios.post(
        `${environment.apiUrl}/agent/getActivityTemplateConfigurationDetails`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      setconfiguration(res?.data);
    } catch (error) {
      console.log('error', error);
      if (
        error?.response?.data?.error === 'jwt malformed' ||
        error?.response?.data?.error === 'jwt expired'
      ) {
        console.log(error?.response?.data?.error);
        navigate('/login');
      }
    }
  };

  const handleInputChange1 = (key, value) => {
    const updatedValues = editConfiguration?.map((item) => {
      // Check if the key is for a MULTICOLUMN field by checking for the presence of []
      if (key.includes('[')) {
        // Extract the fieldKey, rowIndex, and colKey from the key string
        const matches = key.match(/(\w+)\[(\d+)\]\[(\w+)\]/);
        if (matches) {
          const fieldKey = matches[1]; // Example: "exampleKey"
          const rowIndex = parseInt(matches[2], 10); // Example: "0"
          const colKey = matches[3]; // Example: "field_name"

          // If this is the matching field (fieldKey)
          if (item.key === fieldKey) {
            // Create a new array of rows
            const updatedRows = [...item.value];
            // Update the specific column in the specific row
            updatedRows[rowIndex] = {
              ...updatedRows[rowIndex],
              [colKey]: value, // Update the column value
            };
            // Return the updated item with the modified rows
            return { ...item, value: updatedRows };
          }
        }
      }

      // For all other non-MULTICOLUMN fields, update directly
      if (item.key === key) {
        return { ...item, value };
      }

      // Return the item unchanged if it's not the target field
      return item;
    });

    // Update the state
    setEditConfiguration(updatedValues);
    setPrefillInput(updatedValues);
  };

  const handleSave = (data) => {
    console.log('Saved Configuration:', data);
    setaddFlag(true);
    // You can process the saved data here
  };


  useEffect(() => {
    getEditableActivityTemplateForOrg();
    getActivityTypes();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    const filtered = tableData.filter((item) =>
      item.activity_template_name
        .toLowerCase()
        .includes(event.target.value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRowClick = (rowData) => {
    setSelectedRowData(rowData); // Set the clicked row data
    getActivityTemplateDetails(rowData);
    getActivityTemplateConfigurationDetails(rowData);
    setDrawerOpen(true); // Open the drawer
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false); // Close the drawer
    setSelectedRowData(null); // Clear selected row data
    setaddFlag(true);
  };

  const handleFieldChange = (key, value) => {
    setSelectedRowData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    //test
  }, [editConfiguration]);

  return (
    <Box>
      <Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginLeft: '30px',
            marginRight: '30px',
          }}
        >
          <Box sx={{ color: '#131F32', fontWeight: '600', fontSize: '32px' }}>
            AI Tasks
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TextField
              placeholder="Search for AI Tasks"
              value={searchTerm}
              onChange={handleSearchChange}
              variant="outlined"
              size="small"
              sx={{
                width: '300px',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                  '&:hover fieldset': {
                    borderColor: '#159DFF',
                  },
                },
                '& .MuiInputBase-input': {
                  padding: '10px 14px',
                }
              }}
              InputProps={{
                endAdornment: (
                  <IconButton>
                    <SearchIcon sx={{ color: '#159DFF' }}/>
                  </IconButton>
                ),
              }}
            />
            <AddButton
              text={'Add'}
              icon={<Add />}
              sx={{ fontSize: '16px', marginLeft: '30px',color: '#159DFF', marginRight: '30px',border: '1px solid #159DFF', borderRadius: '8px' }}
              handleClick={() => {
                setSelectedRowData({});
                setEditConfiguration([]);
                setconfiguration([]);
                setaddFlag(false);
                setDrawerOpen(true);
              }}
            />
          </Box>
        </Box>

        <TableContainer
          style={{ 
            marginRight: '1%', 
            width: '98%', 
            marginTop: '40px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)' 
          }}
          component={Paper}
        >
          <Table>
            <TableHead style={{ backgroundColor: '#F6F8FA' }}>
              <TableRow>
                <TableCell
                  align="left"
                  sx={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#131F32',
                    paddingLeft: '20px !important',
                    borderBottom: '2px solid #E0E0E0'
                  }}
                >
                  <TableSortLabel>Task Type</TableSortLabel>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#131F32',
                  }}
                >
                  Task
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#131F32',
                  }}
                >
                  Task Description
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#131F32',
                  }}
                >
                  Edit
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center" style={{ padding: '40px 16px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                      <CircularProgress size={40} sx={{ color: '#FFD600' }} />
                      <Typography variant="body2" sx={{ color: '#666', fontSize: '14px' }}>
                        Fetching  data 
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    ?.map((row, index) => (
                    <TableRow 
                      key={index}
                      sx={{
                        '&:hover': {
                          backgroundColor: '#F8F9FA',
                          transition: 'background-color 0.3s'
                        },
                        // cursor: 'pointer'
                      }}
                    >
                      <TableCell 
                        align="left" 
                        style={{ 
                          padding: '16px',
                          color: '#2C3E50',
                          fontSize: '14px'
                        }}
                      >
                        {row.activity_type}
                      </TableCell>
                      <TableCell 
                        align="laft" 
                        style={{ 
                          padding: '16px',
                          color: '#2C3E50',
                          fontSize: '14px'
                        }}
                      >
                        {row.activity_template_name}
                      </TableCell>
                      <TableCell 
                        align="left" 
                        style={{ 
                          padding: '16px',
                          color: '#2C3E50',
                          fontSize: '14px'
                        }}
                      >
                        {row.activity_template_description}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ padding: '16px', cursor: 'pointer' }}
                        onClick={() => handleRowClick(row)}
                      >
                        <Edit sx={{ color: '#808080' }} />
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={filteredData.length}
            page={page}
            rowsPerPageOptions={[5,10, 20, 50, 100]}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>

        {/* Drawer for Editing */}
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={handleCloseDrawer}
          sx={{zIndex:'2000'}}
          PaperProps={{ 
            style: { 
              width: '35%', 
              padding: '30px',
              backgroundColor: '#FFFFFF',
              boxShadow: '-4px 0 12px rgba(0,0,0,0.1)'
            } 
          }}
        >
          <Box
            sx={{
              width: '100%',
              // padding: '20px',
              display: 'flex',
              flexDirection: 'column',
              // height: '650px',
              overflow: 'auto',
              paddingRight: '20px',
              // height: "1000px",
              // background:
              //   "lin0ear-gradient(to right, rgba(255, 205, 0, 0.25) 108%, rgba(255, 205, 0, 0) 0%)",
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: '30px',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{ color: '#131c32', fontWeight: '550', fontSize: '26px' }}
              >
                Add/Edit Task
              </Box>
              <IconButton
                onClick={handleCloseDrawer}
                size="small"
                style={{ position: 'absolute', top: 5, right: 5 }}
              >
                <CloseIcon />
              </IconButton>

              {/* Hello onkar */}
            </Box>

            {selectedRowData && (
              <Box>
                <div
                  style={{
                    margin: '5px',
                    color: '#131F32',
                    fontSize: '14px',
                    fontWeight: '600',
                    lineHeight: '24px',
                  }}
                >
                  Task Type
                </div>
                <Box sx={{ position: 'relative' }}>
                  <TextField
                    size="small"
                    fullWidth
                    value={
                      activityTypesForOrg.find(
                        (activity) =>
                          activity.activityType === selectedRowData.activity_type
                      )?.activityName || ''
                    }
                    onClick={() => setOpenDialog(true)}
                    sx={{
                      marginBottom: '16px',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      '&:hover': {
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#159DFF',
                        }
                      },
                      '&.Mui-focused': {
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#159DFF',
                        }
                      }
                    }}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <IconButton size="small">
                          <ExpandMoreIcon />
                        </IconButton>
                      ),
                    }}
                  />
                  <Dialog
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                    maxWidth="xs"
                    sx={{zIndex:'2005 !important'}}
                    fullWidth
                    PaperProps={{
                      sx: {
                        position: 'absolute',
                        top: '20%',
                        left: '65%',
                        marginTop: '4px',
                        maxHeight: '300px',
                        overflow: 'auto',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                      }
                    }}
                  >
                    <List>
                      {activityTypesForOrg?.map((activity) => (
                        <ListItem
                          key={activity.activityType}
                          button
                          onClick={() => {
                            const selectedActivity = activityTypesForOrg.find(
                              (a) => a.activityName === activity.activityName
                            );
                            if (selectedActivity) {
                              handleFieldChange(
                                'activity_type',
                                selectedActivity.activityType
                              );
                              setEditConfiguration(
                                selectedActivity?.configuration?.taskConfiguration
                              );
                              const newInputValues = {};
                              selectedActivity?.configuration?.taskConfiguration?.forEach(
                                (item) => {
                                  const { key, label, value } = item;
                                  if (
                                    !(inputValues[key]?.length > 0) ||
                                    inputValues[key] === ''
                                  ) {
                                    newInputValues[key] = value;
                                  }
                                }
                              );
                              setInputValues({ ...inputValues, ...newInputValues });
                            }
                            setOpenDialog(false);
                          }}
                          sx={{
                            padding: '12px 16px',
                            '&:hover': {
                              backgroundColor: 'rgba(21, 157, 255, 0.04)'
                            },
                            '&.Mui-selected': {
                              backgroundColor: 'rgba(21, 157, 255, 0.08)',
                              '&:hover': {
                                backgroundColor: 'rgba(21, 157, 255, 0.12)'
                              }
                            }
                          }}
                        >
                          {activity.activityName || activity.activityDescription}
                        </ListItem>
                      ))}
                    </List>
                  </Dialog>
                </Box>
                <div
                  style={{
                    margin: '5px',
                    color: '#131F32',
                    fontSize: '14px',
                    fontWeight: '600',
                    lineHeight: '24px',
                  }}
                >
                  Task Name
                </div>
                <TextField
                  size="small"
                  value={selectedRowData.activity_template_name || ''}
                  onChange={(e) =>
                    handleFieldChange('activity_template_name', e.target.value)
                  }
                  fullWidth
                  sx={{ 
                    marginBottom: '16px',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      '&:hover fieldset': {
                        borderColor: '#159DFF',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#159DFF',
                      }
                    }
                  }}
                />
                <div
                  style={{
                    margin: '5px',
                    color: '#131F32',
                    fontSize: '14px',
                    fontWeight: '600',
                    lineHeight: '24px',
                  }}
                >
                  Task Description
                </div>
                <TextField
                  size="small"
                  value={selectedRowData.activity_template_description || ''}
                  onChange={(e) =>
                    handleFieldChange(
                      'activity_template_description',
                      e.target.value
                    )
                  }
                  fullWidth
                  sx={{ marginBottom: '16px' }}
                />

                {editConfiguration?.map((field) => {
                  const { type, label, minRows, info, key } = field;

                  if (
                    type === 'TEXTINPUT' ||
                    type === 'TEXTAREA' ||
                    type === 'TEXTAREA_L' ||
                    type === 'TEXTAREA_XL'
                  ) {
                    return (
                      <InputField
                        key={label}
                        question={label}
                        label={info || label}
                        type="text"
                        minRows={
                          type === 'TEXTAREA'
                            ? 3
                            : type === 'TEXTAREA_L'
                            ? 5
                            : type === 'TEXTAREA_XL'
                            ? 12
                            : 1
                        }
                        value={field.value || ''}
                        onChange={(e) =>
                          handleInputChange1(key, e.target.value)
                        }
                      />
                    );
                  } else if (type === 'MULTITEXT') {
                    return (
                      <ChipInput
                        key={label}
                        question={label}
                        minRows={3}
                        placeholder={info || label}
                        values={field.value || []}
                        onChipChange={(chips) => handleInputChange1(key, chips)}
                      />
                    );
                  } else if (type === 'MULTICOLUMN') {
                    return (
                      <div key={label}>
                        <h4>{label}</h4>
                        {/* Render column headers only once */}
                        {field.value?.length > 0 && (
                          <div style={{ display: 'flex', fontWeight: 'bold' }}>
                            {field?.columnHeaders?.map((col) => (
                              <div key={col.key} style={{ flex: 1 }}>
                                {col.label}
                              </div>
                            ))}
                          </div>
                        )}
                        {/* Render input fields for each row */}
                        {field.value?.map((row, rowIndex) => (
                          <div
                            key={rowIndex}
                            style={{ display: 'flex', marginBottom: '10px' }}
                          >
                            {field?.columnHeaders?.map((col) => (
                              <div key={col.key} style={{ flex: 1 }}>
                                <input
                                  type="text"
                                  value={row[col.key] || ''}
                                  onChange={(e) =>
                                    handleInputChange1(
                                      `${key}[${rowIndex}][${col.key}]`,
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            ))}
                          </div>
                        ))}
                        <Button
                          onClick={() => handleAddRow(key)}
                          variant="outlined"
                          sx={{
                            marginTop: '10px',
                            borderRadius: '8px',
                            borderColor: '#159DFF',
                            color: '#159DFF',
                            '&:hover': {
                              borderColor: '#0B7ACC',
                              backgroundColor: 'rgba(21, 157, 255, 0.04)'
                            }
                          }}
                        >
                          Add New Row
                        </Button>
                      </div>
                    );
                  }

                  return null;
                })}
                  {addFlag &&<Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '20px',
                  }}
                >
                  <span
                    style={{
                      color: '#131F32',
                      fontSize: '14px',
                      fontWeight: '600',
                    }}
                  >
                    AI Configurations
                  </span>
                  <Box>
                    
                    <VisibilityIcon
                      sx={{
                        cursor: 'pointer',
                        marginRight: 1,
                        color: '#808080',
                      }}
                      onClick={()=>{
                         setDialogOpen(true);
                         setReadOnlyFlag(true);
                      }}
                    />
                    <EditIcon sx={{ cursor: 'pointer', color: '#808080' }}
                      onClick={()=>{
                        setDialogOpen(true);
                     }}
                    />
                  </Box>
                </Box>}
                <ButtonK
                  text="Save"
                  color="#131F32"
                  backgroundColor="#FFD600"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    fontSize: '14px !important',
                    margin: 'auto',
                    marginTop: '70px',
                    marginBottom: '50px',
                    padding: '3px !important',
                    borderRadius: '2px !important',
                    fontWeight: '600',
                  }}
                  handleClick={async () => {
                    try {
                      const data = {
                        activity_template_name: selectedRowData.activity_template_name,
                        activity_template_description: selectedRowData.activity_template_description,
                        configuration: {
                          primary_input: editPrimaryInput,
                          primary_output: editPrimaryOutput,
                          task_configuration: editConfiguration,
                        },
                      };

                      const res = await axios.put(
                        `${environment.controlplaneUrl}/manage/activity-templates/${encodeURIComponent(selectedRowData.activity_template_code)}`,
                        data,
                        {
                          headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`,
                            'Content-Type': 'application/json',
                          },
                        }
                      );
                      getEditableActivityTemplateForOrg();
                      setDrawerOpen(false);
                    } catch (error) {
                      console.log('error', error);
                      if (
                        error?.response?.data?.error === 'jwt malformed' ||
                        error?.response?.data?.error === 'jwt expired'
                      ) {
                        console.log(error?.response?.data?.error);
                        navigate('/login');
                      }
                    }
                  }}
                />
              </Box>
            )}
          </Box>
        </Drawer>
      </Box>

      <Dialog
        open={dialogOpen}
        maxWidth="md"
        sx={{zIndex:'2001'}}
        onClose={() => {
          setReadOnlyFlag(false);
          setDialogOpen(false);
        }}
        PaperProps={{
          style: {
            borderRadius: '12px',
            padding: '10px'
          }
        }}
      >
        <DialogContent sx={{ width: '770px', height: '580px' }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Box
              sx={{ fontSize: '22px', fontWeight: '550', marginBottom: '20px' }}
            >
              AI Configurations
            </Box>
            <IconButton
              onClick={() => {
                setReadOnlyFlag(false);
                setDialogOpen(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          {configuration &&
          <ConfigurationForm configuration={configuration?.configuration} selectedRowData={configuration} readOnlyFlag={readOnlyFlag} />
          }
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default AdminActivityTemplates;
